import { StyledCodeContainer } from './DietAllergenIcon.styles';
import { DietAllergenIconTypes } from './DietAllergenIcon.types';

// This component can be used to render Diet or Allergen Icon
export const DietAllergenIcon = (props: DietAllergenIconTypes) => {
  return <StyledCodeContainer itemType={props?.itemType || ''}>{props?.itemCode || ''}</StyledCodeContainer>;
};
export default DietAllergenIcon;
